<template>
  <div class="typhoon-info">
    <div class="t-header">
      <span>{{ typhoonInfo.name }}</span>
      <img
        src="../assets/images/关闭.png"
        alt=""
        class="el-icon-close"
        @click="$emit('clickTyphoonInfo')"
      />
    </div>
    <div class="t-info">
      <div class="t-item">
        <span>时间：</span>
        <span>{{
          $moment(typhoonInfo.ddateTime).format("YYYY-MM-DD HH:mm")
        }}</span>
      </div>
      <div class="t-item">
        <span>中心位置：</span>
        <span>{{ typhoonInfo.latitude }}N / {{ typhoonInfo.longitude }}E</span>
      </div>
      <div class="t-item">
        <span>风速风力：</span>
        <span typhoonInfo.windSpeed
          >{{ typhoonInfo.windSpeed }}m/s ({{
            mapTyphoonType(typhoonInfo.tcRank)
          }})</span
        >
      </div>
      <div class="t-item">
        <span>中心气压：</span>
        <span>{{ typhoonInfo.pressure }}百帕</span>
      </div>
    </div>
    <span class="trangle"></span>
  </div>
</template>

<script>
export default {
  props: ["typhoonInfo"],
  data() {
    return {};
  },
  methods: {
    mapTyphoonType(type) {
      let strong = null;
      switch (type) {
        case "TD":
          strong = "热带低压";
          break;
        case "TS":
          strong = "热带风暴";
          break;
        case "STS":
          strong = "强热带风暴";
          break;
        case "TY":
          strong = "台风";
          break;
        case "STY":
          strong = "强台风";
          break;
        case "SUPERTY":
          strong = "超强台风";
          break;

        default:
          strong = "";
          break;
      }
      return strong;
    },
  },
};
</script>

<style lang="less" scoped>
.typhoon-info {
  position: relative;
  width: 14.58vw;
  background: #25324d;
  box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  opacity: 0.7;
  border: 1px solid;
  // box-shadow: 0vw 0vw 0.47vw 0vw rgba(184, 184, 184, 0.5);
  .t-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1.04vw;
    font-size: 0.73vw;
    color: white;
    height: 2.71vw;
    background: #15324d;
    border-radius: 0.63vw 0.63vw 0vw 0vw;
    font-size: 0.94vw;
    font-weight: 500;
    color: #81c3ff;
    line-height: 1.3vw;
    img {
      padding-right: 1.04vw;
      cursor: pointer;
    }
  }
  .t-info {
    .t-item {
      padding: 0.26vw 0vw;
      font-size: 0.68vw;
      span:nth-child(1) {
        display: inline-block;
        width: 5.21vw;
        padding: 0;
        text-align: right;
        font-size: 0.83vw;
        color: #fff;
        line-height: 1.45vw;
      }
      span:nth-child(2) {
        font-size: 0.83vw;
        color: #fff;
        line-height: 1.45vw;
      }
    }
  }
  .trangle {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 0;
    transform: translate(-50%, 100%);
    border-left: 0.52vw solid transparent;
    border-right: 0.52vw solid transparent;
    border-top: 0.62vw solid #25324d;
  }
  .el-icon-close {
    color: #333;
    padding-right: 1.04vw;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>
